import { CircleCheck } from 'lucide-react';

export type CheckmarkCircleProps = {
    checked?: boolean | null;
};

export function CheckmarkCircle({
    checked,
}: CheckmarkCircleProps) {
    return (
        <CircleCheck
            className="h-9 w-9 lg:h-7 lg:w-7 xl:h-8 xl:w-8 circle-checkmark-solid p-[1.5px]"
            style={{
                stroke: 'hsl(var(--background))',
                fill: checked
                    ? '#32c770'
                    : 'hsl(var(--border))',
            }}
        />
    );
}
